import {BaseCurrencyCode, DoubleString, Resource} from '@raison/types';
import {DynamicRateItem} from '~/redux/dynamicRate/dynamicRateReducers';

export const selectDynamicRates = (store: AppModel) => store.dynamicRate;

export const selectGrowDynamicResource = (store: AppModel): Resource<DynamicRateItem[]> => {
    const {rates, failed, fetching} = store.dynamicRate;
    if (rates) {
        return Resource.from({isSuccess: true, isFetching: fetching, data: rates});
    }
    if (fetching) {
        return Resource.from({isLoading: true});
    }
    if (failed) {
        return Resource.from({isError: true, error: null});
    }
    return Resource.from({isUninitialized: true});
};

export const selectDynamicsService = (state: AppModel) =>
    selectGrowDynamicResource(state).mapSuccess(dynamicRates => {
        const growDynamics: Record<BaseCurrencyCode, string | undefined> = {};
        for (const dynamic of dynamicRates) {
            growDynamics[dynamic.symbol as BaseCurrencyCode] = dynamic.percent;
        }
        const self = {
            getFor(currency: BaseCurrencyCode) {
                return growDynamics[currency]!;
            },
            getGrowthOf({currencyCode, dynamics}: {currencyCode: BaseCurrencyCode; dynamics?: number | DoubleString}) {
                if (dynamics !== undefined) {
                    return Number(dynamics);
                }
                return Number(growDynamics[currencyCode] ?? 0);
            },
        };
        return self;
    });

export type DynamicsService = Resource.InferData<ReturnType<typeof selectDynamicsService>>;
